import { render, staticRenderFns } from "./BoletoMessage.vue?vue&type=template&id=2a159790&scoped=true"
import script from "./BoletoMessage.vue?vue&type=script&lang=js"
export * from "./BoletoMessage.vue?vue&type=script&lang=js"
import style0 from "./BoletoMessage.vue?vue&type=style&index=0&id=2a159790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a159790",
  null
  
)

export default component.exports